export enum BetslipEventsEnum {
  BetPlaced = 1,
  BetProcessing,
  FindBetByBookId,
  GoToGame,
  SuperbetAccepted,
  ClientIdle,
  ToggleEditMode,
  BetBooked,
  ProfitBoost,
  ChangeBetType,
}


